"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestShiftCreate = void 0;
const query_1 = __importDefault(require("./query"));
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const apollo_1 = require("@app/util/apollo");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const query = (0, graphql_tag_1.default) `mutation ShiftCreateMutation ($workspace: ID!, $data: ShiftData!) {
  shiftCreate (
    workspace: $workspace
    data: $data
  ) ${query_1.default.SHIFT_BASIC}
}`;
const requestShiftCreate = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(query, {
        variables
    });
    (0, error_handler_1.processErrors)(errors, (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('MA_SHIFT')));
    return data?.shiftCreate;
};
exports.requestShiftCreate = requestShiftCreate;
exports.default = exports.requestShiftCreate;
